import * as React from "react";
import { MenuList } from "../menuItems/menuList";
import SupportCenter from "../guestNav/guestNavList";
import { Idevice } from "../../types/device";
import LoginService from "../../service/login/loginService";
import { Link } from "react-router-dom";

export interface IMobCurtainMenuProps {
	rootUrl?: string;
	loggedIn?: boolean;
	deviceState?: Idevice;
}

export function MobCurtainMenu(props: IMobCurtainMenuProps) {
	return (
		<>
			<div className={(props.loggedIn ? "sessionMenu" : "") + " mobCurtainMenu"}>
				<MenuList loggedIn={props.loggedIn} deviceState={props.deviceState} />
			</div>

			<div className="btmFixed taCenter">
				{!props.loggedIn && (
					<>
						
						<a className="openAccBtn openAccBtmFix vMid" href={props.rootUrl + "open-trading-account-online"}>
							Open Account
						</a>
						<a className="loginBtn loginBtmFix vMid" href={props.rootUrl + "/login"}>
							Login
						</a>
						<SupportCenter />
					</>
				)}

				{props.loggedIn && (
					<>
						<Link to="/" className="logoutBtn ib vMid" onClick={LoginService.logout}>
							Logout
						</Link>
					</>
				)}
			</div>
		</>
	);
}
